import { PaymentLimitExceededRptConstants } from '../constants';

export function PaymentLimitExceededRpt(state = {}, action) {
    switch (action.type) {
        case PaymentLimitExceededRptConstants.LOADING_REQUEST:
            return {
                ...state,
                loading: action.isbool
            };
        case PaymentLimitExceededRptConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case PaymentLimitExceededRptConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case PaymentLimitExceededRptConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case PaymentLimitExceededRptConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case PaymentLimitExceededRptConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas
            };
        case PaymentLimitExceededRptConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state
    }
}
